import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { FeatureOptInMemberships } from "@reflag/shared/featureTargetingAPI";

export function useFeatureOptInMembershipsUpdateMutation(featureId: string) {
  const { appId, envId } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    FeatureOptInMemberships,
    AxiosError<ErrorResponse>,
    FeatureOptInMemberships
  >({
    mutationFn: (memberships) =>
      api
        .patch<"/apps/:appId/features/:featureId/opt-in-memberships">(
          `/apps/${appId}/features/${featureId}/opt-in-memberships`,
          memberships,
          { params: { envId } },
        )
        .then((response) => response.data),

    onSuccess: (memberships) => {
      queryClient.setQueryData<FeatureOptInMemberships>(
        featureQueryKeys.optInMemberships(appId, envId, featureId),
        {
          userIds: memberships.userIds,
          companyIds: memberships.companyIds,
        },
      );
      queryClient.invalidateQueries({
        queryKey: featureQueryKeys.single(appId, envId, featureId),
      });
      queryClient.invalidateQueries({
        queryKey: featureQueryKeys.singleFeatureRolloutStatus(
          appId,
          envId,
          featureId,
        ),
      });
    },
  });
}
